const IconSend = ({ className }) => {
    return (
        <svg
            width='32'
            height='32'
            viewBox='0 0 32 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                d='M18.3757 17.0576C18.3757 19.4419 16.4429 21.3747 14.0586 21.3747C11.6743 21.3747 9.74147 19.4419 9.74147 17.0576C9.74147 14.6733 11.6743 12.7405 14.0586 12.7405C16.4429 12.7405 18.3757 14.6733 18.3757 17.0576Z'
                stroke='black'
                strokeWidth='2'
            />
            <path
                d='M12.6699 5.34439C13.2985 4.29536 14.8187 4.29536 15.4473 5.34439L16.8776 7.73139C17.2443 8.34318 17.968 8.64298 18.6599 8.46961L21.3591 7.79317C22.5454 7.49589 23.6203 8.57079 23.323 9.75706L22.6466 12.4563C22.4732 13.1482 22.773 13.872 23.3848 14.2386L25.7718 15.6689C26.8209 16.2976 26.8209 17.8177 25.7718 18.4463L23.3848 19.8767C22.773 20.2433 22.4732 20.9671 22.6466 21.6589L23.323 24.3582C23.6203 25.5444 22.5454 26.6193 21.3591 26.3221L18.6599 25.6456C17.968 25.4723 17.2443 25.7721 16.8776 26.3838L15.4473 28.7708C14.8187 29.8199 13.2985 29.8199 12.6699 28.7708L11.2395 26.3838C10.8729 25.7721 10.1492 25.4723 9.45733 25.6456L6.75804 26.3221C5.57176 26.6193 4.49687 25.5444 4.79415 24.3582L5.47058 21.6589C5.64395 20.9671 5.34415 20.2433 4.73237 19.8767L2.34537 18.4463C1.29634 17.8177 1.29634 16.2976 2.34537 15.6689L4.73237 14.2386C5.34415 13.872 5.64395 13.1482 5.47058 12.4564L4.79415 9.75706C4.49687 8.57079 5.57176 7.49589 6.75804 7.79317L9.45733 8.46961C10.1492 8.64298 10.8729 8.34318 11.2395 7.73139L12.6699 5.34439Z'
                stroke='black'
                strokeWidth='2'
            />
        </svg>
    );
};

export default IconSend;
